import { Modal, Spinner } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { MyProjects } from '@platform/client';
import { useState } from 'react';
import * as Sentry from '@sentry/react';

export const CancelPendingIntroductionsModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const queryClient = useQueryClient();
  const closeAllPendingConnectionsMutation = MyProjects.useCloseUserPendingConnections({
    mutation: {
      onMutate: () => {
        setIsSubmitting(true);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: MyProjects.getGetProUserMyProjectsQueryKey() });
        setIsOpen(false);
      },
      onError: (err) => {
        setIsSubmitting(false);
        Sentry.captureException(err);
      },
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      headerDivision='divider'
      variant='dialog'
      title='Cancel pending'
      primaryCTA={{
        text: 'Cancel pending',
        callback: () => {
          closeAllPendingConnectionsMutation.mutate({ params: { notify: true } });
        },
        buttonVariant: 'primary-danger',
        isDisabled: () => isSubmitting,
      }}
      secondaryCTA={{
        text: 'Go back',
        callback: () => setIsOpen(false),
        buttonVariant: 'secondary-gray',
        isDisabled: () => isSubmitting,
      }}
      ignoreExtraPadding
    >
      <div className='flex flex-col gap-4 items-center max-w-[500px]'>
        {isSubmitting ?
          <Spinner />
        : <>
            <div>
              MovingWorlds will notify your pending connections and introductions that you're no
              longer available because you found a different match.
            </div>
            <div>
              This is a good option for Experteers who want to work on only one project at a time.
              Learn if this is right for you.
            </div>
          </>
        }
      </div>
    </Modal>
  );
};
